<app-bringoz-data-table [uniqueId]="tableUniqueId"
                        [defaultWidths]="defaultWidths"
                        [items]="providers"
                        [rowHeight]="rowHeight"
                        [resizable]="true"
                        [isLoading]="isLoading">

  <ng-template tableHeader>
    <!-- col-name is pinned left and col-actions right by TableColumnManager - renaming them unpins those columns. -->
    <div class="th col-name text-ellipsis">{{ "Provider's Name" | translate }}</div>
    <div class="th col-description text-ellipsis">{{ 'Description' | translate }}</div>
    <div class="th col-type text-ellipsis">{{ 'Type' | translate }}</div>
    <div class="th col-resolver text-ellipsis">{{ 'Resolver' | translate }}</div>
    <div class="th col-active text-ellipsis">{{ 'Active' | translate }}</div>
    <div class="th col-actions"></div>
  </ng-template>

  <ng-template tableRow let-provider>
    <app-site-providers-table-row [provider]="provider"
                                  (onEdit)="onEdit.emit(provider)"
                                  (onArchive)="onArchive.emit(provider)"
                                  (onActiveChange)="onActiveChange.emit({provider: provider, active: $event})">
    </app-site-providers-table-row>
  </ng-template>

  <app-empty-state tableEmptyState
                   src="assets/images/empty_state/empty_state_location_box.svg"
                   text="No providers found">
  </app-empty-state>

</app-bringoz-data-table>
